export default __webpack_public_path__ + "static/media/1E54D64E-8F8F-4901-80F4-C3BA9C6EDA64.cb75267c.mov";